export const log = (message?: any, ...optionalParams: any[]) =>
	console.log(message, ...optionalParams);

export const error = (message?: any, ...optionalParams: any[]) =>
	console.error(message, ...optionalParams);
